export default __webpack_public_path__ + "assets/icons/direction.9a9b9a5b.svg";